export const calculateDiscount = function (
    amount,
    discount
) {
  /** tax is stored as a integer Value between 1 and 100 */
  let discountFactor = 1 - (discount / 100);
  console.log(discountFactor);
  return Math.round((amount * discountFactor + Number.EPSILON) * 100) / 100
}